import requestHandler from './requestHandler'

export default {
  get: function (url, opts) {
    const duration = (opts && opts.duration)
    let cachePolicy = (opts && opts.cachePolicy)

    if(duration && !cachePolicy) {
      cachePolicy = `max-age=${duration}`
    }

    return requestHandler(url, {
      cachePolicy
    })
  }
}



// WEBPACK FOOTER //
// ./lib/memoizr.js